import { headers } from "../../../config/config";
import { AUTHORIZATION } from "../../../constants/api/auth";
import { MESSAGE } from "../../../constants/api/message";
import { Group } from "../../../types/group.types";
import { request } from "../api";

const { Bearer, Authorization } = AUTHORIZATION;
const { get } = request;
const initialRoute = "admin/group";

type GroupAndLocation = {
	group: {
		group_name: string;
	};
};

type GroupAndLocationQuery = {
	group_number: number;
};

const getGroupByAuth = async (): Promise<Group> => {
	try {
		const endpoint = `${initialRoute}/auth`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			Authorization: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

const getGroupAndLocation = async (query: GroupAndLocationQuery): Promise<GroupAndLocation> => {
	try {
		const endpoint = `${initialRoute}/group-and-location`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(
			endpoint,
			{
				Authorization: `${Bearer} ${token}`
			},
			query
		);
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

const initialRoute2 = "groups";
const getGroupByGroupNumber = async (group_number: number) => {
	try {
		console.log("Hello", group_number);
		const endpoint = `${initialRoute2}/group-by-group-number/${group_number}`;
		const token = localStorage.getItem("@jwt_member");
		const response = await get(endpoint, {
			...headers,
			[Authorization]: `${Bearer} ${token}`
		});
		if (response) {
			const {
				data: { message }
			} = response;
			if (message === MESSAGE.get.succ) {
				const {
					data: { result }
				} = response;
				return result;
			}
		}
		throw new Error();
	} catch (err) {
		throw err;
	}
};

export const group = {
	getGroupAndLocation,
	getGroupByAuth,
	getGroupByGroupNumber
};
